import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        country: String,
    };

    static targets = [
        'saveButton',
        'errorContainer',
        'errorContainerCharactersLeft',
        'barreauSelect',
        'swornDateYear',
        'registrationNumber',
        'noRegistrationNumberButton',
    ];

    swornDateYear = null;
    registrationNumber = null;
    registrationNumberButtonActive = null;

    connect() {
        // The bar list (FR/BE only) is a searchable select2. It used to be set up for every
        // page by the Hyper theme's hyper.js, which is gone (DDT-3772). The dropdown is
        // rendered inside the modal: on <body> it sits under the Bootstrap 5 modal.
        if (this.hasBarreauSelectTarget) {
            $(this.barreauSelectTarget).select2({ dropdownParent: $(this.element) });
        }
    }

    disconnect() {
        if (this.hasBarreauSelectTarget && $(this.barreauSelectTarget).data('select2')) {
            $(this.barreauSelectTarget).select2('destroy');
        }
    }

    openModal() {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });

        this.swornDateYear = this.swornDateYearTarget.value;
        if (this.countryValue === 'fr' || this.countryValue === 'gb') {
            this.registrationNumber = this.registrationNumberTarget.value;
        }

        if (this.countryValue === 'fr') {
            this.registrationNumberButtonActive = this.noRegistrationNumberButtonTarget.classList.contains('active');
        }
    }

    closeModal() {
        $(this.element).modal('hide');

        this.registrationNumberTarget.value = this.registrationNumber;
        this.swornDateYearTarget.value = this.swornDateYear;

        if (this.countryValue === 'fr' && !this.registrationNumberButtonActive) {
            this.noRegistrationNumberButtonTarget.classList.remove('active');
        }
    }

    submitForm() {
        showPreloader();
        let data = {};

        if (this.countryValue === 'fr') {
            data = {
                barreau: this.barreauSelectTarget.value,
                swornDateYear: this.swornDateYearTarget.value,
                noRegistrationNumber: this.noRegistrationNumberButtonTarget.classList.contains('active'),
                registrationNumber: this.registrationNumberTarget.value,
            };
        } else if (this.countryValue === 'gb') {
            data = {
                swornDateYear: this.swornDateYearTarget.value,
                registrationNumber: this.registrationNumberTarget.value,
            };
        } else if (this.countryValue === 'be') {
            data = {
                barreau: this.barreauSelectTarget.value,
                swornDateYear: this.swornDateYearTarget.value,
            };
        }

        $.ajax({
            url: routes['app_profile_barreaufieldsupdate'],
            data: data,
            success: (response) => {
                if (response.status) {
                    $(this.element).modal('hide');

                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'barreau | Success',
                            'label': GA_EVENT_LABEL,
                        },
                    });

                    window.location.reload();
                } else {
                    hidePreloader();
                }
            },
            error: function(error, res) {
                const json = error.responseJSON;

                if (json.message) {
                    addAlert('danger', json.message);
                    return;
                }

                addAlert('danger', translations['profile.An unknown error occurred.']);
            },
        });
    }

    noRegistrationNumberButtonPress() {
        if (this.noRegistrationNumberButtonTarget.classList.contains('active')) {
            this.noRegistrationNumberButtonTarget.classList.remove('active');
        } else {
            this.registrationNumberTarget.value = '';
            this.noRegistrationNumberButtonTarget.classList.add('active');
        }
    }

    registrationNumberChanged() {
        this.noRegistrationNumberButtonTarget.classList.remove('active');
    }
}
